import React from 'react';
import { CheckIcon } from 'lucide-react';
export function TrainerAuthority() {
  return <section className="w-full bg-[#0a0a0a] py-20 sm:py-24 px-4 sm:px-6 lg:px-8 border-t border-[#1a1a1a]" data-id="element-447">
      <div className="max-w-7xl mx-auto" data-id="element-448">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-449">
          {/* Left: Image */}
          <div className="order-1 relative" data-id="element-450">
            {/* Subtle glow behind the certificate */}
            <div className="absolute -inset-4 bg-gradient-to-tr from-[#C9A84C]/10 to-transparent blur-2xl pointer-events-none" data-id="element-451" />

            <img src="https://cdn.magicpatterns.com/uploads/etE6HJMPdJiYCRN1NYjMgc/PHOTO-2026-03-06-13-56-01.jpg" alt="Certificado Cinturón Negro - Federación Española de Kickboxing" className="relative w-full h-auto border border-[#C9A84C]/30 shadow-2xl shadow-black/80 object-contain bg-black/50" data-id="element-452" />
          </div>

          {/* Right: Content */}
          <div className="order-2 flex flex-col justify-center" data-id="element-453">
            <h2 className="font-heading font-bold text-white uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight mb-6" data-id="element-454">
              Formación y <br className="hidden sm:block lg:hidden" data-id="element-455" />
              <span className="text-[#C9A84C]" data-id="element-456">Experiencia Real</span>
            </h2>

            <p className="font-body text-gray-300 text-lg sm:text-xl mb-8 leading-relaxed" data-id="element-457">
              Antonio no solo enseña. Cuenta con reconocimiento oficial en
              deportes de combate.
            </p>

            <ul className="space-y-5" data-id="element-458">
              <li className="flex items-start gap-4" data-id="element-459">
                <span className="flex-shrink-0 w-6 h-6 rounded bg-[#C9A84C]/15 border border-[#C9A84C]/40 flex items-center justify-center mt-0.5" data-id="element-460">
                  <CheckIcon size={13} className="text-[#C9A84C]" data-id="element-461" />
                </span>
                <span className="font-body text-gray-300 text-base sm:text-lg leading-relaxed" data-id="element-462">
                  Cinturón negro 1º grado
                </span>
              </li>
              <li className="flex items-start gap-4" data-id="element-463">
                <span className="flex-shrink-0 w-6 h-6 rounded bg-[#C9A84C]/15 border border-[#C9A84C]/40 flex items-center justify-center mt-0.5" data-id="element-464">
                  <CheckIcon size={13} className="text-[#C9A84C]" data-id="element-465" />
                </span>
                <span className="font-body text-gray-300 text-base sm:text-lg leading-relaxed" data-id="element-466">
                  Reconocimiento de la Federación Española de Kickboxing
                </span>
              </li>
              <li className="flex items-start gap-4" data-id="element-467">
                <span className="flex-shrink-0 w-6 h-6 rounded bg-[#C9A84C]/15 border border-[#C9A84C]/40 flex items-center justify-center mt-0.5" data-id="element-468">
                  <CheckIcon size={13} className="text-[#C9A84C]" data-id="element-469" />
                </span>
                <span className="font-body text-gray-300 text-base sm:text-lg leading-relaxed" data-id="element-470">
                  Experiencia como competidor y entrenador
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}